// extracted by extract-css-chunks-webpack-plugin
module.exports = {"category_topCMS":"css-2hoHfK0k_-"};